import {
  Component, EventEmitter,
  Input, Output
} from '@angular/core';
import {AbstractControl, Form, FormControl, ValidatorFn, Validators} from '@angular/forms';


/**
 * [TODO: Description of counter goes here]
 */
@Component({
  selector: 'clo-input-counter',
  templateUrl: './counter-input.html',
  styleUrls: ['./input.scss']

})
export class CloInputCounter {

  @Input() minValue = 0;

  @Input() maxValue: number;

  @Input() quantity: number;

  @Input() incrementValue = 1;

  input: FormControl;
  errorMessage: string;

  @Output() valueChanged = new EventEmitter();
  @Output() invalid = new EventEmitter();

  ngOnInit() {
    this.input = new FormControl(
      '',
      [Validators.required, Validators.max(this.maxValue), Validators.min(this.minValue), matchStep(this.incrementValue)]
    );
    this.input.registerOnChange( (newValue: number) => {
      if (newValue !== this.quantity) {
        this.quantity = newValue;
        this.valueChanged.emit(this.quantity);
      }

      if (this.input.invalid) {
        this.invalid.emit(this.input.errors);
      }
    });

    if (!this.quantity) {
      this.quantity = (this.minValue) ? this.minValue : 0;
    }

    this.input.setValue(this.quantity);
  }

  incrementQuantity() {
    const value = this.input.value;

    if (this.maxValue === undefined || value < this.maxValue) {
      const newValue = this.input.value + this.incrementValue;
      const rounded = Math.round(newValue / this.incrementValue ) * this.incrementValue;
      this.input.setValue(rounded);
      this.valueChanged.emit(this.quantity);
    }
  }

  decrementQuantity() {
    const value = this.input.value;
    if (value > this.minValue) {
      const newValue = this.input.value - this.incrementValue;
      const rounded = Math.round(newValue / this.incrementValue ) * this.incrementValue;
      this.input.setValue(rounded);
      this.valueChanged.emit(this.quantity);
    }
  }
  onChange(event) {
    this.valueChanged.emit(this.quantity);
  }
}

export function matchStep(step): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const forbidden = (control.value % step) > 0;
    return forbidden ? {'matchStep': {value: control.value}} : null;
  };
}
